import { InitialTpaPlugins } from './types';
import { AdditionalBookings } from './additional-time-slots/controller';

export const initialTpaPlugins = async (context: InitialTpaPlugins) => {
  await new AdditionalBookings(context).runListeners();
};
